exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/sass-loader/dist/cjs.js!./src/routes/main/userprofile/tab-feed/TabFeed.scss
// module id = 1300
// module chunks = 62